import { useNavigate } from "react-router-dom";
import LegalLayout from "@/pages/LegalLayout";

const H2 = ({ children }) => (
  <h2 className="mb-2.5 mt-8 text-[18px] font-medium text-brand-ink">{children}</h2>
);

const COOKIES = [
  { name: "cookie-consent", type: "Técnica", owner: "Propia", purpose: "Recordar tu elección sobre las cookies", duration: "Persistente" },
  { name: "_gcl_au y similares", type: "Publicitaria", owner: "Google", purpose: "Medir conversiones de campañas de Google Ads", duration: "Hasta 90 días" },
];

export default function Cookies() {
  const navigate = useNavigate();

  const reopen = () => {
    localStorage.removeItem("cookie-consent");
    navigate("/");
  };

  return (
    <LegalLayout title="Política de cookies" docTitle="Política de cookies — Asistentes Virtual">
      <H2>1. ¿Qué son las cookies?</H2>
      <p>
        Las cookies son pequeños archivos que se almacenan en tu dispositivo al visitar una web
        y que permiten, entre otras cosas, recordar tus preferencias o medir el rendimiento de
        campañas publicitarias.
      </p>

      <H2>2. Cookies que utiliza este sitio</H2>
      <div className="overflow-x-auto">
        <table className="mt-2 w-full border-collapse text-[13.5px]">
          <thead>
            <tr>
              {["Cookie", "Tipo", "Titular", "Finalidad", "Duración"].map((h) => (
                <th key={h} className="border border-brand-line bg-brand-bgAlt px-3 py-2 text-left font-medium text-brand-ink">
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {COOKIES.map((c) => (
              <tr key={c.name}>
                <td className="border border-brand-line px-3 py-2">{c.name}</td>
                <td className="border border-brand-line px-3 py-2">{c.type}</td>
                <td className="border border-brand-line px-3 py-2">{c.owner}</td>
                <td className="border border-brand-line px-3 py-2">{c.purpose}</td>
                <td className="border border-brand-line px-3 py-2">{c.duration}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mt-3">
        Las cookies publicitarias de Google solo se instalan si las aceptas expresamente en el
        banner de cookies. Mientras no aceptes, permanecen desactivadas (Consent Mode v2). Puedes
        consultar cómo usa Google los datos en{" "}
        <a href="https://policies.google.com/technologies/partner-sites" rel="noopener noreferrer" target="_blank" className="text-brand-indigo underline">
          policies.google.com
        </a>.
      </p>

      <H2>3. Cómo cambiar tu elección</H2>
      <p>Puedes retirar o modificar tu consentimiento en cualquier momento:</p>
      <button
        onClick={reopen}
        data-testid="reopen-cookie-banner"
        className="mt-3 rounded-[9px] bg-brand-indigo px-5 py-2.5 text-[14px] font-medium text-white transition-transform duration-200 hover:-translate-y-0.5"
      >
        Cambiar mis preferencias de cookies
      </button>
      <p className="mt-4">
        También puedes eliminar las cookies desde la configuración de tu navegador (Chrome,
        Firefox, Safari o Edge disponen de opciones para bloquear o borrar cookies).
      </p>

      <p className="mt-8 text-[13px]">Última actualización: [FECHA]</p>
    </LegalLayout>
  );
}
